export default [
  // {
  //   category: true,
  //   title: 'Ajustes',
  // },
  // {
  //   title: 'Usuarios',
  //   key: 'settingsUsers',
  //   icon: 'fe fe-user',
  //   url: '/settings/users',
  // },
  // {
  //   title: 'Módulos',
  //   key: 'settingsModules',
  //   icon: 'fe fe-layers',
  //   url: '/settings/modules',
  // },
  // {
  //   category: true,
  //   title: 'Dashboard',
  // },
  // {
  //   title: 'Reportes',
  //   key: 'dashboardAnalytics',
  //   icon: 'fe fe-activity',
  //   url: '/dashboard/analytics',
  // },
  {
    category: true,
    title: 'Módulos',
  },
]
